import { isObjectEmpty, isCountryChinaOrJapan, isCountryJapan, isCountrySweden } from '../helper/functions';
import * as REGEX from './regexPatterns';
import * as ldapDataService from '../services/ldapDataService';
import * as stringConstants from '../constants/stringConstants';
import {
  isBillingCountryAndCountryFrance,
  isTaxFieldVisible,
} from '../helper/utilityMethods';
import * as inputFieldValidatorConstants from '../constants/constFileLabelsVendor'

const validateInputs = (page, setFormErrors, formData, isNextClicked = false) => {
  if (!isNextClicked) {
    return;
  }
  let errors;
  switch (page) {
    case 1:
      errors = validateSupplierContactInfo(formData);
      setFormErrors(errors);
      return isObjectEmpty(errors);
    case 2:
      errors = validateSupplierOtherInfo(formData);
      setFormErrors(errors);
      return isObjectEmpty(errors);
    case 3:
      errors = validateSupplierBankingInfo(formData);
      setFormErrors(errors);
      return isObjectEmpty(errors);
    case 4:
      errors = validateAmexContactInfo(formData);
      setFormErrors(errors);
      return isObjectEmpty(errors);
    default:
      return false;
  }
};
const validateField = (input, type, name) => {
  let error = '';
  switch (type) {
    case inputFieldValidatorConstants.REQUIRED_FIELD_VALIDATOR:
      if (!input?.trim()) {
        error = `${name} is required`;
      }
      else if (name === 'City' 
      || name === 'State/Province' 
      || name === 'Postal Code' )
      {
      if (!REGEX.dashAplphanumericRegexPattern.test(input?.trim())) {
        error = inputFieldValidatorConstants.DASH_ALPHANUMERIC_REGEX_MESSAGE;
       }
    }
      return error;
    case inputFieldValidatorConstants.EMAIL_FIELD_VALIDATOR:
      if (!input?.trim()) {
        error = `${name} Email Address is required`;
      } else if (!REGEX.emailRegexPattern.test(input)) {
        error = 'Please enter a valid Email address';
      }
      return error;
    case 'amexEmail':
      if (!input?.trim()) {
        error = `${name} Email Address is required`;
      } else if (!REGEX.amexEmailRegexPattern.test(input?.toLowerCase())) {
        error = 'Please enter a valid Amex Email address';
      }
      return error;
    case inputFieldValidatorConstants.PHONE_FIELD_VALIDATOR:
      if (!input?.trim()) {
        error = `${name} Phone number is required`;
      } else if (!REGEX.phoneNoRegexPattern.test(input?.trim())) {
        error = 'Only numbers are allowed';
      }
      return error;
    case inputFieldValidatorConstants.DASH_ALPHANUMERIC_REGEX_VALIDATOR:
     if (!REGEX.dashAplphanumericRegexPattern.test(input?.trim())) {
        error = inputFieldValidatorConstants.DASH_ALPHANUMERIC_REGEX_MESSAGE;
      }
      return error;
  }
};
const validateSupplierContactInfo = (formData) => {
  const errors = {};
  const isCountryJapanOrChina = isCountryChinaOrJapan(formData.billingCountry?.CountryName ?? '');

  if (!formData.region.RegionCode?.trim()) {
    errors.region = 'Region is required';
  }
  if (!formData.billingCountry.CountryName?.trim()) {
    errors.billingCountry = 'Billing Country is required';
  }
  if (
    formData.billingCountry.CountryName?.toLowerCase() === 'other' &&
    !formData.otherCountry?.trim()
  ) {
    errors.otherCountry = 'Other Country is required';
  }
  if (!formData.billingCurrency.CurrencyName?.trim()) {
    errors.billingCurrency = 'Billing Currency is required';
  }
  if (!formData?.supplierRegisteredName?.trim()) {
    errors.supplierRegisteredName = 'Supplier Registered Name is required';
  }
  if (isCountryJapanOrChina && !formData.supplierRegisteredLocalName?.trim()) {
    errors.supplierRegisteredLocalName = 'Supplier Registered Name in Local Language is required';
  }
  if (!formData.supplierRegisteredAddress_Line1?.trim()) {
    errors.supplierRegisteredAddress_Line1 = 'Supplier Registered Address Line1 is required';
  }
  if (isCountryJapanOrChina && !formData.supplierRegisteredLocalAddress_Line1?.trim()) {
    errors.supplierRegisteredLocalAddress_Line1 =
      'Supplier Registered Local Address Line1 is required';
  }
  if (isCountryJapanOrChina && !formData.payeeLocalName?.trim()) {
    errors.payeeLocalName = 'Payee Local Name is required';
  }
  if (isCountryJapanOrChina && !formData.payeeLocalAddress_Line1?.trim()) {
    errors.payeeLocalAddress_Line1 = 'Payee Local Address is required';
  }
  if (!formData.city?.trim()) {
    errors.city = 'City is required';
  } else if (!REGEX.dashAplphanumericRegexPattern.test(formData.city?.toLowerCase() ?? '')) {
    errors.city = inputFieldValidatorConstants.DASH_ALPHANUMERIC_REGEX_MESSAGE;
  }
  if (!REGEX.dashAplphanumericRegexPattern.test(formData.payeeState?.toLowerCase())) {
    errors.payeeState = inputFieldValidatorConstants.DASH_ALPHANUMERIC_REGEX_MESSAGE;
  }
  if (!REGEX.dashAplphanumericRegexPattern.test(formData.payeePostalCode?.toLowerCase() ?? '')) {
    errors.payeePostalCode = inputFieldValidatorConstants.DASH_ALPHANUMERIC_REGEX_MESSAGE;
  }
  if (!REGEX.dashAplphanumericRegexPattern.test(formData.payeeCity?.toLowerCase() ?? '')) {
    errors.payeeCity = inputFieldValidatorConstants.DASH_ALPHANUMERIC_REGEX_MESSAGE;
  }
  if (!formData.state?.trim()) {
    errors.state = 'State/Province is required';
  } else if (!REGEX.dashAplphanumericRegexPattern.test(formData.state?.toLowerCase() ?? '')) {
    errors.state = inputFieldValidatorConstants.DASH_ALPHANUMERIC_REGEX_MESSAGE;
  }
  if (!formData.postalCode?.trim()) {
    errors.postalCode = 'Postal Code is required';
  } else if (!REGEX.dashAplphanumericRegexPattern.test(formData.postalCode?.toLowerCase() ?? '')) {
    errors.postalCode = inputFieldValidatorConstants.DASH_ALPHANUMERIC_REGEX_MESSAGE;
  }
  if (!formData.country.CountryName?.trim()) {
    errors.country = 'Country is required';
  }
  if (!formData.supplierContactPerson?.trim()) {
    errors.supplierContactPerson = "Supplier's Contact Person is required";
  }
  if (!formData.supplierEmailAddress?.trim()) {
    errors.supplierEmailAddress = "Supplier's Email Address is required";
  } else if (!REGEX.emailRegexPattern.test(formData.supplierEmailAddress)) {
    errors.supplierEmailAddress = 'Please enter a valid email address';
  }

  if (!formData.supplierPhoneNumber?.trim()) {
    errors.supplierPhoneNumber = "Supplier's Phone Number is required";
  } else if (!REGEX.phoneNoRegexPattern.test(formData.supplierPhoneNumber)) {
    errors.supplierPhoneNumber = 'Only numbers are allowed';
  }
  if (!formData.acknowledgementCheck) {
    errors.acknowledgementCheck = inputFieldValidatorConstants.CHECKBOX_ERROR_MESSAGE;
  }
    return errors;
};

const validateSupplierOtherInfo = (formData) => {
  const errors = {};

  if (isTaxFieldVisible(stringConstants.NIF, formData.billingCountry.CountryName)
    && !formData.nif?.trim()) {
    errors.nif = 'NIF code is required';
  }

  if (isTaxFieldVisible(stringConstants.IS_MSME, formData.billingCountry.CountryName)
    && !formData.isMsme?.trim()) {
    errors.isMsme = 'Supplier registered under MSME is required';
  }
  if (isTaxFieldVisible(stringConstants.PAN, formData.billingCountry.CountryName)
    && !formData.panNo?.trim()) {
    errors.panNo = 'PAN No is required';
  }
  if (isTaxFieldVisible(stringConstants.SERVICE_TAX, formData.billingCountry.CountryName)
    && !formData.serviceTaxNo?.trim()) {
    errors.serviceTaxNo = 'Service Tax No is required';
  }
  if (isTaxFieldVisible(stringConstants.ABN, formData.billingCountry.CountryName)
    && !formData.abn?.trim()) {
    errors.abn = 'ABN# is required';
  }
  if (isTaxFieldVisible(stringConstants.REGISTERED_STATE, formData.billingCountry.CountryName)
    && !formData.registeredState?.trim()) {
    errors.registeredState = 'States where supplier has registered for sales & use tax is required';
  }
  if (isTaxFieldVisible(stringConstants.REGISTRATION_NUMBER, formData.billingCountry.CountryName)
    && !formData.registeredStateNo?.trim()) {
    errors.registeredStateNo = 'Registration Number for each State is required';
  }
  if (isTaxFieldVisible(stringConstants.UEN, formData.billingCountry.CountryName)
    && !formData.uen?.trim()) {
    errors.uen = 'UEN# is required';
  }
  if (isTaxFieldVisible(stringConstants.BUSINESS_REG_CERT_NO, formData.billingCountry.CountryName)
    && !formData.businessRegCertNo?.trim()) {
    errors.businessRegCertNo = 'Business Registration Certificate No is required';
  }
  if (isTaxFieldVisible(stringConstants.TIN, formData.billingCountry.CountryName)
    && !formData.tin?.trim()) {
    errors.tin = 'TIN# is required';
  }
  if (!formData.gstNo?.trim()) {
    errors.gstNo = 'GST No/Tax ID is required';
  }
  if (isBillingCountryAndCountryFrance(formData.billingCountry.CountryName, formData.country.CountryName)) {
    if (!formData?.sirenNumber?.trim()) {
      errors.sirenNumber = 'SIREN Number is required';
    } else if (!REGEX.dashAplphanumericRegexPattern.test(formData.sirenNumber?.toLowerCase() ?? '')) {
      errors.sirenNumber = inputFieldValidatorConstants.DASH_ALPHANUMERIC_REGEX_MESSAGE;
    }
    if (!formData?.siretNumber?.trim()) {
      errors.siretNumber = 'SIRET Number is required';
    } else if (!REGEX.dashAplphanumericRegexPattern.test(formData.siretNumber?.toLowerCase() ?? '')) {
      errors.siretNumber = inputFieldValidatorConstants.DASH_ALPHANUMERIC_REGEX_MESSAGE;
    }
  }
  if (!formData.isAuditFirm?.trim()) {
    errors.isAuditFirm = 'Audit Firm is required';
  }
  if (!formData.paymentMethod?.trim()) {
    errors.paymentMethod = 'Payment Method is required';
  }
  if (!formData.remittanceEmailAddress?.trim()) {
    errors.remittanceEmailAddress = 'Remittance Email Address is required';
  } else if (!REGEX.emailRegexPattern.test(formData.remittanceEmailAddress)) {
    errors.remittanceEmailAddress = 'Please enter a valid email address';
  }
  if (!formData.paymentTerms?.trim()) {
    errors.paymentTerms = 'Payment Terms is required';
  }
  if (formData.paymentMethod?.toLowerCase() === 'cpc' && !formData.serviceEstablishment?.trim()) {
    errors.serviceEstablishment = 'Please enter the Service Establishment #.';
  }
  if (formData.paymentMethod?.toLowerCase() === 'other' && !formData.otherPaymentMethod?.trim()) {
    errors.otherPaymentMethod = 'Please specify other Payment Method';
  }

  return errors;
};

// TODO: Implement validations as per selected Bank transfer
const validateSupplierBankingInfo = (formData) => {
  const paymentMethod = formData.paymentMethod?.toLowerCase();
  const errors = {};

  if (isCountryJapan(formData.billingCountry.CountryName)) {
    if (!formData.japanBranchName?.trim()) {
      errors.japanBranchName = 'Japan Located Branch Name is required';
    }
    if (!formData.japanBankName?.trim()) {
      errors.japanBankName = 'Japan Located Bank Name is required';
    }
  }

  if (isCountrySweden(formData.billingCountry.CountryName)) {
    if (!formData?.bankGiroNumber?.trim()) {
      errors.bankGiroNumber = 'Bank Giro/Plus Giro is required';
    }
  }

  if (!REGEX.dashAplphanumericRegexPattern.test(formData.bankName?.toLowerCase())) {
    errors.bankName = inputFieldValidatorConstants.DASH_ALPHANUMERIC_REGEX_MESSAGE;
  }
  if (!REGEX.dashAplphanumericRegexPattern.test(formData.branchName?.toLowerCase())) {
    errors.branchName = inputFieldValidatorConstants.DASH_ALPHANUMERIC_REGEX_MESSAGE;
  }
  if (!REGEX.dashAplphanumericRegexPattern.test(formData.branchCode?.toLowerCase())) {
    errors.branchCode = inputFieldValidatorConstants.DASH_ALPHANUMERIC_REGEX_MESSAGE;
  }
  if (!REGEX.dashAplphanumericRegexPattern.test(formData.bic?.toLowerCase())) {
    errors.bic = inputFieldValidatorConstants.DASH_ALPHANUMERIC_REGEX_MESSAGE;
  }
  if (!REGEX.dashAplphanumericRegexPattern.test(formData.aba?.toLowerCase())) {
    errors.aba = inputFieldValidatorConstants.DASH_ALPHANUMERIC_REGEX_MESSAGE;
  }
  if (!REGEX.dashAplphanumericRegexPattern.test(formData.bankCode?.toLowerCase())) {
    errors.bankCode = inputFieldValidatorConstants.DASH_ALPHANUMERIC_REGEX_MESSAGE;
  }
  if (!REGEX.dashAplphanumericRegexPattern.test(formData.intermediateBankName?.toLowerCase())) {
    errors.intermediateBankName = inputFieldValidatorConstants.DASH_ALPHANUMERIC_REGEX_MESSAGE;
  }
  if (!REGEX.dashAplphanumericRegexPattern.test(formData.intermediateBankBic?.toLowerCase())) {
    errors.intermediateBankBic = inputFieldValidatorConstants.DASH_ALPHANUMERIC_REGEX_MESSAGE;
  }
  if (!REGEX.dashAplphanumericRegexPattern.test(formData.intermediateBankBranchName?.toLowerCase())) {
    errors.intermediateBankBranchName = inputFieldValidatorConstants.DASH_ALPHANUMERIC_REGEX_MESSAGE;
  }
  if (!REGEX.dashAplphanumericRegexPattern.test(formData.intermediateBankBranchCode?.toLowerCase())) {
    errors.intermediateBankBranchCode = inputFieldValidatorConstants.DASH_ALPHANUMERIC_REGEX_MESSAGE;
  }

  if (
    paymentMethod === 'eft' ||
    paymentMethod === 'wire' ||
    paymentMethod === 'fx wire' ||
    paymentMethod === 'ach' ||
    paymentMethod === 'electronic'
  ) {
    if (!formData.bankName?.trim()) {
      errors.bankName = 'Bank Name is required';
    }else if (!REGEX.dashAplphanumericRegexPattern.test(formData.bankName?.toLowerCase())) {
      errors.bankName = inputFieldValidatorConstants.DASH_ALPHANUMERIC_REGEX_MESSAGE;
    }
    if (!formData.branchName?.trim()) {
      errors.branchName = 'Branch Name is required';
    }else if (!REGEX.dashAplphanumericRegexPattern.test(formData.branchName?.toLowerCase())) {
      errors.branchName = inputFieldValidatorConstants.DASH_ALPHANUMERIC_REGEX_MESSAGE;
    }
    if (!formData.branchCode?.trim()) {
      errors.branchCode = 'Branch Code is required';
    }else if (!REGEX.dashAplphanumericRegexPattern.test(formData.branchCode?.toLowerCase())) {
      errors.branchCode = inputFieldValidatorConstants.DASH_ALPHANUMERIC_REGEX_MESSAGE;
    }
    if (!formData.bic?.trim()) {
      errors.bic = 'BIC/Swift Code is required';
    }else if (!REGEX.dashAplphanumericRegexPattern.test(formData.bic?.toLowerCase())) {
      errors.bic = inputFieldValidatorConstants.DASH_ALPHANUMERIC_REGEX_MESSAGE;
    }
    if (!formData.accountNumber?.trim()) {
      errors.accountNumber = 'Account Number is required';
    }
    if (
      (formData.billingCountry.CountryName?.toLowerCase() === 'australia' ||
      formData.billingCountry.CountryName?.toLowerCase() === 'new zealand') && !formData.aba?.trim()
    ) {
      errors.aba = 'ABA/Routing No./BSB/Sort Code is required';
    }else if (!REGEX.dashAplphanumericRegexPattern.test(formData.aba?.toLowerCase())) {
      errors.aba = inputFieldValidatorConstants.DASH_ALPHANUMERIC_REGEX_MESSAGE;
    }
    if (formData.region.RegionCode?.toLowerCase() === 'emea' && !formData.bankCode?.trim()) {
      errors.bankCode = 'Bank Code/IBAN Code is required';
    }else if (!REGEX.dashAplphanumericRegexPattern.test(formData.bankCode?.toLowerCase())) {
      errors.bankCode = inputFieldValidatorConstants.DASH_ALPHANUMERIC_REGEX_MESSAGE;
    }
    if (!REGEX.dashAplphanumericRegexPattern.test(formData.intermediateBankName?.toLowerCase())) {
      errors.intermediateBankName = inputFieldValidatorConstants.DASH_ALPHANUMERIC_REGEX_MESSAGE;
    }
    if (!REGEX.dashAplphanumericRegexPattern.test(formData.intermediateBankBic?.toLowerCase())) {
      errors.intermediateBankBic = inputFieldValidatorConstants.DASH_ALPHANUMERIC_REGEX_MESSAGE;
    }
    if (!REGEX.dashAplphanumericRegexPattern.test(formData.intermediateBankBranchName?.toLowerCase())) {
      errors.intermediateBankBranchName = inputFieldValidatorConstants.DASH_ALPHANUMERIC_REGEX_MESSAGE;
    }
    if (!REGEX.dashAplphanumericRegexPattern.test(formData.intermediateBankBranchCode?.toLowerCase())) {
      errors.intermediateBankBranchCode = inputFieldValidatorConstants.DASH_ALPHANUMERIC_REGEX_MESSAGE;
    }
  }

  return errors;
};

const validateAmexContactInfo = (formData) => {
  const errors = {};

  if (!formData.amexContactName?.trim()) {
    errors.amexContactName = 'Amex Contact Name is required';
  }
  if (!formData.amexContactEmail?.trim()) {
    errors.amexContactEmail = 'Amex Contact Email is required';
  } else if (!REGEX.amexEmailRegexPattern.test(formData.amexContactEmail?.toLowerCase())) {
    errors.amexContactEmail = 'Please enter a valid amex e-mail address.';
  }
  if (!formData.amexContactNumber?.trim()) {
    errors.amexContactNumber = 'Amex Contact Number is required';
  } else if (!REGEX.phoneNoRegexPattern.test(formData.amexContactNumber?.trim())) {
    errors.amexContactNumber = 'Only numbers are allowed';
  }

  return errors;
};

const validateAmexContactEmailId = async (emailId, setFormErrors) => {
  const adsData = await ldapDataService.getADSDataByEmail(emailId)
    .then((res) => res.data)
    .catch(err => ({ADS_ID: null}));
 
  if (!(adsData.ADS_ID)) {
    setFormErrors({
      amexContactEmail: 'Please enter a valid amex e-mail address.',
    });
    return false;
  }

  return true;
};

// TODO: refactor export bucket
export {
  validateInputs,
  validateSupplierContactInfo,
  validateSupplierOtherInfo,
  validateSupplierBankingInfo,
  validateAmexContactInfo,
  validateAmexContactEmailId,
  validateField,
};
